export type TiktokPrivacyLevel =
  | "PUBLIC_TO_EVERYONE"
  | "MUTUAL_FOLLOW_FRIENDS"
  | "FOLLOWER_OF_CREATOR"
  | "SELF_ONLY"

export type TiktokPostState = {
  privacy: TiktokPrivacyLevel | ""
  allowComments: boolean
  allowDuet: boolean
  allowStitch: boolean
  commercialContent: boolean
  yourBrand: boolean
  brandedContent: boolean
}

export type TiktokCreatorInfo = {
  creator_nickname: string | null
  creator_username: string | null
  creator_avatar_url: string | null
  privacy_level_options: TiktokPrivacyLevel[]
  comment_disabled: boolean
  duet_disabled: boolean
  stitch_disabled: boolean
  max_video_post_duration_sec: number | null
}

export const PRIVACY_LABELS: Record<TiktokPrivacyLevel, string> = {
  PUBLIC_TO_EVERYONE: "Everyone",
  MUTUAL_FOLLOW_FRIENDS: "Friends",
  FOLLOWER_OF_CREATOR: "Followers",
  SELF_ONLY: "Only me",
}

export const INITIAL_TIKTOK_STATE: TiktokPostState = {
  privacy: "",
  allowComments: false,
  allowDuet: false,
  allowStitch: false,
  commercialContent: false,
  yourBrand: false,
  brandedContent: false,
}

export function isTiktokStateValid(state: TiktokPostState): boolean {
  if (!state.privacy) return false
  if (state.commercialContent && !state.yourBrand && !state.brandedContent) return false
  if (state.brandedContent && state.privacy === "SELF_ONLY") return false
  return true
}
